import React from 'react';

const TaskBoxAction = ({ children }) => (
  <div className="layout-row layout-align-end-center flex-33">{children}</div>
);

export default TaskBoxAction;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/TaskBoxAction.jsx